import { render, staticRenderFns } from "./Kampagne.vue?vue&type=template&id=22fe8ff0&"
import script from "./Kampagne.vue?vue&type=script&lang=js&"
export * from "./Kampagne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports